import { schema, types } from 'papr'

const ALLOWED_STATUS = ['failed' as const, 'success' as const]
const ALLOWED_PROVIDERS = ['github' as const]
const ALLOWED_OPERATIONS = ['create' as const, 'update' as const, 'Synced existing file' as const]

/**
 * Schema representing a backup of either a post or a draft.
 */
export const backupDeliverySchema = schema({
	provider: types.enum(ALLOWED_PROVIDERS, { required: true }),
	user: types.objectId(),
	publication: types.objectId({ required: true }),
	// either post or draft
	post: types.objectId(),
	draft: types.objectId(),
	operation: types.enum(ALLOWED_OPERATIONS, { required: true }),
	status: types.enum(ALLOWED_STATUS, { required: true }),
	remarks: types.string(),
	dateAdded: types.date({ required: true }),
})

export type BackupDeliveryDocument = (typeof backupDeliverySchema)[0]
export type BackupDeliveryDefaults = (typeof backupDeliverySchema)[1]
